export default (username: string) => {
    return /blog\/(pr_clanok|pr_clanek)\//.test(username);
};

// above function seem buggy AF
export const usernameIsPr = (username: string): boolean => {
    return username === 'pr_clanok' || username == 'pr_clanek'
}